module.exports = __webpack_public_path__ + "static/media/double-bounce.8c1901e3.less";